export default {"src":"/_next/static/media/ZContentSystemLight.71a0537a.svg","height":229,"width":345};